import { theme as themeLib } from '@ppay/client'
import merge from 'lodash.merge'

const colors = {
  primary: '#7333CC',
  lightPrimary: '#E3D8F4',
  primaryShade2: '#8C4DE6',
  purple: '#663664',
  // Soft tinted background for informational cards (manual order states, support card).
  // Was '#e5efff', a pale blue left over from the old blue brand.
  infoBackground: '#f0eafb',
  tertiary: '#2E243D',
  tertiaryShade: '#928B9D',
  tertiaryShade2: '#ADA9B2'
}

const radius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px'
}

export const theme = merge(themeLib, { colors, radius })

export type Theme = typeof theme
